<template>
    <div class="statistic-wrap">
        <div class="card statistic-table" >
          <div :class="className">
            <div class="card-header" v-if="title">
                {{ title }}
                <div class="card-actions">
                    <slot name="table-actions"></slot>
                    <button class="btn-close" @click="exporting"><i class="fa fa-download"></i></button>
                    <button  @click="exportingAll" class="btn-close" v-if="isExelAll"><i class="fa fa-file-excel-o"></i></button>
                </div>
            </div>
            <div class="card-block" :id="id" :class="{cardFixed: isFixed}">
                <table class="table">
                    <thead>
                    <tr v-if="preheatColumns">
                        <th v-for="col in preheatColumns" :colspan="col.colspan">
                          {{ col.label }}
                        </th>
                    </tr>
                    <tr>
                        <th v-if="checkbox">
                          <input type="checkbox"
                            class="checkall"
                            v-model="status.all"
                            v-bind:value="status.all"
                            @change="check('all')" />
                        </th>
                        <th v-for="col in computedHeadColumns" :colspan="col.colspan"
                            :style="renderBackground(false, col.field, false)"
                            @click="!col.splitter ? sort(col) : () => false"
                            class="th-action"
                            :class="{isFix: col.fix, bgCountry: col.field_country, noActive: col.isActive ? 'noActive' : '', 'th-splitter': col.splitter}"
                            :width="col.width ? col.width : 'auto'"
                        >
                          <div v-if="col.splitter" class="th-split-left" @click="sort(col)"></div>
                          <div v-if="col.splitter" class="th-split-right" @click="sort(col, false)"></div>
                          {{ col.label }}
                          <i v-if="rows.length && col.field === copyIcon" class="fa fa-lg fa-copy copy-icon" @click="copyIconClick"></i>
                        </th>
                    </tr>
                    </thead>

                    <tbody v-if="!isLoading">
                    <tr v-for="row in computedRows">

                        <td v-if="checkbox">
                          <input type="checkbox"
                            :class="'check_'+row.id.value"
                            v-model="status[row.id.value]"
                            :value="status[row.id.value]"
                            @change="check(row.id.value)" />
                        </td>
                        <td v-for="(cell, i) in row" v-if="!cell.code" :colspan="cell.colspan" :style="renderBackground(cell, i, false)"
                            :class="getCellClasses(cell)" @change="updates(cell,$event.target.value)" @click="cell.webGraph ? webGraph(cell, i) : (cell.popup) ? isPopup(cell, i): null"  v-html="!cell.htmlValue ? cell.value : cell.htmlValue" >
                        </td>
                        <td  class="col-md-2" v-else><div class="col-md-8" style="display: inline-block">{{cell.value}}</div><div class="col-md-4" style="float:right"><i class="option__image flag" :class="'flag-' + cell.code.toLowerCase()" style="margin: -5px 0 -10px 0;"></i></div></td>
                    </tr>
                    </tbody>

                    <div class="table-loader" style="padding: 50px 0; text-align: center; width: 100%" v-if="isLoading">
                        <i class="fa fa-spinner fa-spin fa-5x fa-fw"></i>
                    </div>

                    <tfoot>
                    <tr v-for="(cell, i) in computedFootCourier" class="normal-text tr_courier" >
                        <th class="flypost_corier_name">{{ cell.courier_name}}</th>
                        <th style="background-color: #e0e0e0;" >{{ cell.total }}</th>
                        <th >{{ parseFloat((cell.total / cell.totalPercents) * 100).toFixed(2)}}%</th>
                        <th style="background-color: #90caf9;">{{ cell.delivered }}</th>
                        <th class="averageBuyback" style="background-color: #bae0ff; white-space: nowrap;">{{cell.paid > 0 ? '$ ' + (cell.average_buyout / cell.paid).toFixed(2) : '$ 0.00'}}</th>
                        <th style="background-color: #ce93d8;font-weight: normal;">{{ cell.refunded }}</th>
                        <th >{{  cell.returnPercents}}</th>
                        <th style="background-color: #fff9c4;">{{ cell.shipped }}</th>
                        <th style="background: #b9f6ca;">{{ cell.buyout }}</th>
                        <th style="background: rgba(156,255,112,0.56)" v-if="isFlypost">{{ cell.cost }}</th>
                        <th >{{ cell.buyout }}</th>
                    </tr>

                    <tr v-for="(cell, i) in computedFootCourier" class="normal-text tr_flypost" >
                        <th @click="isPopupFlyPost(cell)" class="flypost_corier_name">{{ cell.courier_name }}</th>
                        <th style="background-color: #e0e0e0;" >{{ cell.total }}</th>
                        <th >{{ parseFloat((cell.total / cell.totalPercents) * 100).toFixed(2)}}%</th>
                        <th style="background-color: #90caf9;">{{ cell.delivered }}</th>
                        <th style="background-color: #ce93d8;font-weight: normal;">{{ cell.refunded }}</th>
                        <th >{{  cell.returnPercents}}</th>
                        <th style="background-color: #fff9c4;">{{ cell.shipped }}</th>
                        <th style="background: #b9f6ca;">{{ cell.buyout }}</th>
                        <th style="background: rgba(156,255,112,0.56)" v-if="isFlypost">{{ cell.cost }}</th>
                        <th >{{ cell.buyout }}</th>
                    </tr>
                    <tr>
                        <th v-if="checkbox">
                        </th>
                        <th v-for="(cell, i) in computedFootColumns" :style="renderBackground(false, i, cell)" :colspan="cell.colspan"
                            :class="cell.graph ? 'th-action' : null || cell.isActive ? 'noActive' : ''" @click="cell.graph ? renderChart(cell, i) : (cell.popup) ? isPopup(cell, i) : null" :width="cell.width ? cell.width : 'auto'"
                        >
                            <span>{{ cell.value }}</span>
                        </th>
                    </tr>
                    </tfoot>
                </table>
            </div>
          </div>
            <modal effect="fade/zoom" large v-if="id && !isFlypostModal" v-model="chartModal">
                <div slot="modal-header" class="modal-header">
                    <h4 class="modal-title">{{ chart.title }}</h4>
                </div>
                <div :id="`chart-container-${id}`"></div>
                <div slot="modal-footer" class="modal-footer">
                    <button type="button" class="btn btn-info" @click="chartModal = false"> {{ $t('verbs.close') }}
                    </button>
                </div>
            </modal>
        </div>
    </div>
</template>

<script>
  import { orderBy, map } from 'lodash'
  import TypeColor from './../assets/TypeColor'
  import Highcharts from 'highcharts'
  import FileSaver from 'file-saver'
  import MultiSelect from 'vue-multiselect'
  import { modal, dropdown } from 'vue-strap'
  import Storage from './../api/Storage'
  import moment from 'moment'

  export default {
    components: {
      modal,
      MultiSelect,
      dropdown
    },
    props: {
      isActive: {
        type: Boolean,
        required: false
      },
      isExelAll: {
        type: Boolean,
        required: false
      },
      isFlypostModal: {
        type: Boolean,
        required: false
      },
      isFlypost: {
        type: Boolean,
        required: false
      },
      isFixed: {
        type: Boolean,
        required: false
      },
      title: {
        type: String,
        required: false
      },
      checkbox: false,
      checked: {},
      className: {
        type: String,
        required: false
      },
      classes: {
        type: String,
        required: false
      },
      headColumns: {
        type: Array,
        required: true
      },
      rows: {
        type: Array,
        required: true
      },
      footColumns: {
        type: Object,
        required: true
      },
      columns: {
        type: Object,
        required: false
      },
      preheatColumns: {
        type: Array,
        required: false
      },
      totalColumnsDd: {
        type: Object,
        required: false
      },
      copyIcon: {
        type: String,
        default: ''
      }
    },
    data () {
      return {
        id: null,
        isLoading: false,
        chartModal: false,
        order: 'asc',
        totalCells: {},
        status: {},
        TypeColor: TypeColor,
        Storage: Storage,
        chart: {
          isBuilded: false,
          isHidden: false,
          title: {
            text: null
          },
          subtitle: {
            text: null
          },
          credits: {
            enabled: false
          },
          yAxis: [{
            title: {
              text: null
            },
            tickInterval: 1
          }],
          tooltip: {
            valueSuffix: null
          },
          xAxis: {
            type: 'datetime',
            labels: {
              format: '{value:%Y-%m-%d}'
            }
          },
          series: []
        }
      }
    },
    name: 'StatisticTable',
    mounted () {
      this.id = Math.random().toString(36).replace(/[^a-z]+/g, '').substr(0, 8)
      this.$root.$on('data_loading', () => {
        this.isLoading = true
      })
      this.$root.$on('data_loaded', () => {
        this.isLoading = false
      })
    },
    computed: {
      computedHeadColumns () {
        if (!this.columns) {
          return this.headColumns
        } else {
          let headColumns = []
          this.headColumns.map((d) => {
            if (this.columns[d.field]) {
              headColumns.push(d)
            }
          })
          return headColumns
        }
      },
      computedFootColumns () {
        if (!this.columns) {
          return this.footColumns
        } else {
          let footColumns = {}
          map(this.footColumns, (d, i) => {
            if (this.columns[i] || i === 'label' || this.columns[i.replace('Percents', '')]) {
              footColumns[i] = d
            }
          })
          return footColumns
        }
      },
      computedFootCourier () {
        if (!this.columns) {
          return this.totalColumnsDd
        } else {
          let totalColumnsDd = {}
          map(this.totalColumnsDd, (d, i) => {
            if (this.columns[i] || i === 'label' || this.columns[i.replace('Percents', '')]) {
              totalColumnsDd[i] = d
            }
          })
          return totalColumnsDd
        }
      },
      computedRows () {
        if (!this.columns) {
          this.createCheckbox()
          return this.rows
        } else {
          let rows = []
          this.rows.map((row) => {
            let tmpRow = {}
            map(row, (d, i) => {
              if (this.columns[i] || this.columns[i.replace('Percents', '')]) {
                tmpRow[i] = d
              }
            })
            rows.push(tmpRow)
          })
          this.createCheckbox()
          return rows
        }
      }
    },
    methods: {
      getCellClasses (cell) {
        let classes = []
        classes.push(cell.isCollspaned ? 'no-border' : null)
        classes.push(cell.is_new === 1 ? 'web' : null)
        classes.push(cell.isActive ? 'noActive' : null)
        classes.push(cell.percentBg ? 'percentBg' : null)
        classes.push(cell.minusBg ? 'minusBg' : null)
        classes.push(cell.plusBg ? 'plusBg' : null)
        if (parseInt(cell.statusStop) > 0 && parseInt(cell.statusFilter) === 0) {
          classes.push('statusRed')
        }
        if (parseInt(cell.statusStop) === 0 && parseInt(cell.statusFilter) > 0) {
          classes.push('statusYellow')
        }
        if (parseInt(cell.statusStop) > 0 && parseInt(cell.statusFilter) > 0) {
          classes.push('statusBlue')
        }
        if (cell.colouredDayOff) {
          const day = new Date(cell.value).getDay()
          classes.push(day === 0 || day === 6 ? 'coloured_day_off' : null)
        }
        return classes.join(' ')
      },
      exporting (evt) {
        if (this.classes) {
          const classes = document.getElementsByClassName(this.classes)
          let doc = `<html xmlns:o="urn:schemas-microsoft-com:office:office" xmlns:x="urn:schemas-microsoft-com:office:excel" xmlns="http://www.w3.org/TR/REC-html40"><head><meta charset="UTF-8"><!--[if gte mso 9]><xml><x:ExcelWorkbook><x:ExcelWorksheets><x:ExcelWorksheet><x:Name>${this.title}</x:Name><x:WorksheetOptions><x:DisplayGridlines/></x:WorksheetOptions></x:ExcelWorksheet></x:ExcelWorksheets></x:ExcelWorkbook></xml><![endif]--></head><body>`
          doc += `<div>${moment(this.classes).format('MMMM YYYY')}</div><br/>`
          map(classes, (cl, i) => {
            doc += `${cl.innerHTML}<br/>`
          })
          doc += '</body></html>'
          FileSaver.saveAs(new Blob([doc], {
            encoding: 'UTF-8',
            type: 'application/octet-stream'
          }), `analytics-${this.classes}.xls`)
        } else {
          let doc = `<html xmlns:o="urn:schemas-microsoft-com:office:office" xmlns:x="urn:schemas-microsoft-com:office:excel" xmlns="http://www.w3.org/TR/REC-html40"><head><meta charset="UTF-8"><!--[if gte mso 9]><xml><x:ExcelWorkbook><x:ExcelWorksheets><x:ExcelWorksheet><x:Name>${this.title}</x:Name><x:WorksheetOptions><x:DisplayGridlines/></x:WorksheetOptions></x:ExcelWorksheet></x:ExcelWorksheets></x:ExcelWorkbook></xml><![endif]--></head><body>`
          doc += document.getElementById(this.id).innerHTML
          doc += '</body></html>'
          FileSaver.saveAs(new Blob([doc], {
            encoding: 'UTF-8',
            type: 'application/octet-stream'
          }), `analytics-${this.title}-${new Date().toLocaleString()}.xls`)
        }
      },
      exportingAll () {
        this.$emit('exportingAll')
      },
      sort (col, isLeft = true) {
        this.order = (this.order === 'asc' ? 'desc' : 'asc')
        const that = this

        this.rows = orderBy(this.rows, [function (item) {
          if (col.splitter && !isLeft) {
            return !item[col.field].ocb ? item[col.field].bgg : item[col.field].ocb(item[col.field].bgg)
          }

          if (item[col.field].orderData !== undefined) {
            return !item[col.field].ocb ? item[col.field].orderData : item[col.field].ocb(item[col.field].orderData)
          } else {
            return !item[col.field].ocb ? item[col.field].value : item[col.field].ocb(item[col.field].value)
          }
        }], [this.order])
      },
      renderBackground (cell, i, bc) {
        let style = !cell.style ? {} : cell.style
        if (!cell || (cell.bgg === undefined && !cell.dbgg)) {
          style.backgroundColor = !cell.bgc ? this.TypeColor[i] : cell.bgc
        } else {
          if (!cell.dbgg) {
            if (!cell.bgl) {
              style.background = `linear-gradient(to right, ${!cell.bggc ? this.TypeColor[i] : cell.bggc} ${cell.bgg}%, transparent 0%)`
            } else {
              style.background = `linear-gradient(to left, ${!cell.bggc ? this.TypeColor[i] : cell.bggc} ${cell.bgg}%, transparent 0%)`
              style.position = `relative`
            }
          } else {
            style.background = `linear-gradient(to right, ${this.TypeColor[cell.dbgg[0].name]} ${cell.dbgg[0].width}%, ${this.TypeColor[cell.dbgg[1].name]} ${cell.dbgg[0].width}%, ${this.TypeColor[cell.dbgg[1].name]} ${cell.dbgg[0].width + cell.dbgg[1].width}%, transparent 0%)`
          }
        }
        if (bc.bc) {
          style.backgroundColor = `${bc.bc}`
          style.color = bc.c
        }
        if (cell.bgColorTwo) {
          const summ = Math.abs(cell.bgColorTwo.max.value) + Math.abs(cell.bgColorTwo.min.value)
          const minPercent = ((Math.abs(cell.bgColorTwo.min.value) / summ) * 100).toFixed(0)
          const maxPercent = ((Math.abs(cell.bgColorTwo.max.value) / summ) * 100).toFixed(0)
          let percent
          if (cell.bgColorTwo.value < 0) {
            percent = (Math.abs(cell.bgColorTwo.value) / Math.abs(cell.bgColorTwo.min.value) * minPercent) + parseInt(maxPercent)
            style.background = `linear-gradient(to left, transparent 0%, transparent ${maxPercent}%, ${cell.bgColorTwo.min.color} ${maxPercent}%, ${cell.bgColorTwo.min.color} ${percent}%, transparent ${percent}%, transparent 100%)`
          } else {
            percent = (Math.abs(cell.bgColorTwo.value) / Math.abs(cell.bgColorTwo.max.value) * maxPercent) + parseInt(minPercent)
            style.background = `linear-gradient(to right, transparent 0%, transparent ${minPercent}%, ${cell.bgColorTwo.max.color} ${minPercent}%, ${cell.bgColorTwo.max.color} ${percent}%, transparent ${percent}%, transparent 100%)`
          }
          style.position = `relative`
        }
        return style
      },
      renderChart (cell, i) {
        if (!cell.graph) {
          return false
        }
        const rows = orderBy(this.rows, [function (item) {
          return item.date.value
        }], ['asc'])
        let series = []
        map(rows, (row) => {
          if (!cell.graph.cb) {
            series.push([Date.parse(row[Object.keys(row)[0]].value), row[i].value])
          } else {
            series.push([Date.parse(row[Object.keys(row)[0]].value), cell.graph.cb(row[i].value)])
          }
        })
        if (cell.graph.symbol) {
          this.chart.tooltip.valueSuffix = cell.graph.symbol
        } else {
          this.chart.tooltip.valueSuffix = null
        }
        this.chart.title = this.$root.$t(`statistic.${i}`)
        this.chart.series[0] = {
          data: series,
          color: TypeColor[i],
          name: this.$root.$t(`statistic.${i}`)
        }
        this.chart.yAxis[0].min = 0
        this.chart.yAxis[0].title.text = cell.symbol ? cell.symbol : this.$root.$t(`statistic.${i}`)
        Highcharts.chart(`chart-container-${this.id}`, this.chart)
        this.toggleModal()
      },
      toggleModal () {
        this.chartModal = !this.chartModal
      },
      createCheckbox () {
        if (this.checkbox) {
          this.rows.map((val, key) => {
            this.$set(this.status, key, true)
          })
          this.$set(this.status, 'all', true)
        }
      },
      check (poles) {
        if (poles === 'all') {
          this.rows.map((val, key) => {
            this.$set(this.status, key, this.status.all)
          })
          this.chekeds()
        } else {
          this.chekeds()
        }
      },
      chekeds () {
        let checka = true
        let summ = {}
        this.rows.map((val, key) => {
          map(this.checked[key].total, (val1, key1) => {
            if (key === 0) {
              summ[key1] = 0
            }
            if (this.status[key] === false) {
              checka = false
            } else {
              summ[key1] += this.checked[key].total[key1].count
            }
          })
        })
        map(summ, (val, key) => {
          this.footColumns[key].value = summ[key]
        })
        this.$set(this.status, 'all', checka)
      },
      updates (cell, cvalue) {
        this.$emit('changeElem', cell, cvalue)
        return false
      },
      webGraph (cell, i) {
        if (!cell.webGraph) {
          return false
        }
        this.$emit('webGraph', cell, i)
      },
      copyIconClick (e) {
        e.stopPropagation()
        this.$emit('copy')
      },
      isPopup (cell, i) {
        if (!cell.popup) {
          return false
        }
        this.$emit('isPopup', cell, i)
      },
      isPopupFlyPost (cell) {
        this.$emit('isPopupFlyPost', cell)
      }
    }
  }
</script>

<style scoped>
.normal-text th {
    font-weight: normal !important;
}
.web {
    background-color: #D0F0C0;
}
.isFix {
    position: sticky;
    top: 0;
    border-top: none !important;
}
.noActive {
    display: none;
}
.cardFixed {
    display: block !important;
    overflow-y: auto;
    height: 680px;
    padding: 0;
}
.bgCountry {
    background-color: #cfd8dc;
    z-index: 9999;
}
.minusBg {
  background-color: rgb(239, 154, 154)!important;
}
.plusBg {
    background: rgb(200, 230, 201)!important;
}
.statusRed {
    background-color: rgb(239, 154, 154);
}
.statusYellow {
    background-color: rgb(255, 249, 196);
}
.statusBlue {
    background-color: rgb(186, 224, 255);
}

.th-splitter {
  position: relative;
}

.th-split-left {
  position: absolute;
  top: 0;
  left: 0;
  width: 50%;
  height: 100%;
  transition: all .2s ease;
}

.th-split-right {
  position: absolute;
  top: 0;
  right: 0;
  width: 50%;
  height: 100%;
  transition: all .2s ease;
}

.th-split-left:hover, .th-split-right:hover {
  background-color: #e5e5e5;
}

.copy-icon {
  margin: 8px;
}
</style>



// WEBPACK FOOTER //
// StatisticTable.vue?26602dcc